<!--
 * @Author: rzdata
 * @Date: 2026-07-28
 * @Description: 已出库UDI码页面（法规要求）
-->
<template>
  <div v-loading.fullscreen="loading" class="list" element-loading-text="加载中">
    <el-card>
      <condition-search ref="search" :query-items="queryItems" :search-param="searchParam" @search="search"
        @reset="reset">
        <template #extraBtns>
          <el-button type="primary" v-if="btnsPermission('order:exportedUdi:downloadSelected')" :disabled="selectedRows.length === 0" @click="handleDownloadSelected">下载选中({{ selectedRows.length }})</el-button>
          <el-button type="primary" v-if="btnsPermission('order:exportedUdi:export')" @click="handleExport">导出UDI数据</el-button>
          <el-button type="primary" plain v-if="btnsPermission('order:exportedUdi:downloadRecord')" @click="openDownloadDrawer">下载记录</el-button>
        </template>
      </condition-search>
    </el-card>
    <el-card>
      <el-table ref="table1" border :data="pageListData" :height="heightStyleObj" style="width:100%;margin-top: 10px"
        row-key="id" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="bizId" label="单据编号" min-width="150">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openOrderDetail(row)">{{ row.bizId }}</el-button>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="udiCode" label="UDI码" min-width="180" />
        <el-table-column show-overflow-tooltip prop="goodsName" label="医疗器械名称" min-width="150" />
        <el-table-column show-overflow-tooltip prop="specification" label="规格型号" min-width="120" />
        <el-table-column show-overflow-tooltip prop="detailedNumber" label="数量" min-width="80" />
        <el-table-column show-overflow-tooltip prop="batchNumber" label="生产批号" min-width="120" />
        <el-table-column show-overflow-tooltip prop="expiryDate" label="失效日期" min-width="100" />
        <el-table-column show-overflow-tooltip prop="salesDate" label="销售日期" min-width="100" />
        <el-table-column show-overflow-tooltip prop="customer" label="购货单位名称" min-width="150" />
        <el-table-column show-overflow-tooltip prop="customerName" label="客户" min-width="150" />
        <el-table-column show-overflow-tooltip prop="customerAddress" label="地址" min-width="200" show-overflow-tooltip />
        <el-table-column show-overflow-tooltip prop="customerTelephone" label="联系方式" min-width="120" />
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :page-sizes="[10, 50, 100, 500]"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>

    <!-- 下载记录抽屉 -->
    <download-drawer ref="downloadDrawer"></download-drawer>
    <!-- 单据详情抽屉 -->
    <order-detail-drawer ref="orderDetailDrawer"></order-detail-drawer>
  </div>
</template>

<script>
import { getStockRemovalUdiCode, exportOutstockUdiData, exportSelectedUdiData } from '@/api/orderManage'
import { parseTime } from '@/utils/ruoyi'
import { btnsPermission } from '@/utils/btnPermission'
import downloadDrawer from './components/downloadDrawer.vue'
import orderDetailDrawer from './components/infomation.vue'

export default {
  components: {
    'download-drawer': downloadDrawer,
    'order-detail-drawer': orderDetailDrawer
  },
  data() {
    return {
      pageListData: [],
      selectedRows: [],
      selectedIds: new Set(),
      loading: false,
      searchParam: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        searchValue: '',
        salesDateRange: null,
        startDate: '',
        endDate: ''
      },
      queryItems: [
        {
          label: '关键字搜索',
          field: 'searchValue',
          placeholder: '医疗器械名称/单据编号/UDI码/批号/购货单位名称',
          width: '400px',
          type: 'input'
        },
        {
          label: '销售日期',
          field: 'salesDateRange',
          type: 'dateRange'
        }
      ],
      heightStyleObj: ''
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getPageListData()
  },
  methods: {
    btnsPermission,
    parseTime,
    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.clearSelection()
      if (this.searchParam.salesDateRange && this.searchParam.salesDateRange.length === 2) {
        this.searchParam.startDate = this.searchParam.salesDateRange[0] + ' 00:00:00'
        this.searchParam.endDate = this.searchParam.salesDateRange[1] + ' 23:59:59'
      } else {
        this.searchParam.startDate = ''
        this.searchParam.endDate = ''
      }
      this.getPageListData()
    },
    // 重置
    reset() {
      this.searchParam.pageNum = 1
      this.searchParam.searchValue = ''
      this.searchParam.salesDateRange = null
      this.searchParam.startDate = ''
      this.searchParam.endDate = ''
      this.clearSelection()
      this.getPageListData()
    },
    // 获取分页列表数据
    async getPageListData() {
      this.clearSelection()
      this.loading = true
      try {
        const res = await getStockRemovalUdiCode(this.searchParam)
        if (res.code === 200) {
          this.pageListData = res.rows || []
          this.searchParam.total = res.total || 0
        }
      } finally {
        this.loading = false
      }
    },
    // 导出UDI数据
    handleExport() {
      const hasCondition = this.searchParam.searchValue ||
                          (this.searchParam.salesDateRange && this.searchParam.salesDateRange.length === 2)
      if (!hasCondition) {
        this.$confirm('当前未设置查询条件，导出将下载全部数据，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doExport()
        }).catch(() => {})
      } else {
        this.doExport()
      }
    },
    async doExport() {
      this.loading = true
      try {
        const res = await exportOutstockUdiData(this.searchParam)
        if (res.code === 200) {
          this.$message.success(res.msg || '正在生成导出文件，请稍后在下载记录中查看')
        }
      } finally {
        this.loading = false
      }
    },
    // 打开下载记录抽屉
    openDownloadDrawer() {
      this.$refs.downloadDrawer.open()
    },
    // 打开单据详情抽屉
    openOrderDetail(row) {
      this.$refs.orderDetailDrawer.open({ orderId: row.orderId })
    },
    // 处理表格选择变化
    handleSelectionChange(selection) {
      const seenIds = new Set()
      this.selectedRows = selection.filter(row => {
        if (seenIds.has(row.ogoodsInstId)) {
          return false
        }
        seenIds.add(row.ogoodsInstId)
        return true
      })
      this.selectedIds = new Set(this.selectedRows.map(row => row.ogoodsInstId))
    },
    // 清空选中状态
    clearSelection() {
      this.selectedRows = []
      this.selectedIds = new Set()
      if (this.$refs.table1) {
        this.$refs.table1.clearSelection()
      }
    },
    // 下载选中记录
    async handleDownloadSelected() {
      if (this.selectedIds.size === 0) {
        this.$message.warning('请先选择要下载的记录')
        return
      }
      this.loading = true
      try {
        const res = await exportSelectedUdiData({ idList: Array.from(this.selectedIds) })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(res)
        link.download = '已出库UDI码.xlsx'
        link.click()
        this.$message.success('下载成功')
      } catch (error) {
        this.$message.error('下载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
